<template>
    <van-row>

        <br>

        <van-row v-show="'success'!=step">
            <van-row style="margin: auto 10px">
                <van-form label-width="5em" :colon="true" @submit="onSubmit">
                    <van-field
                            v-model="item.name"
                            :required="true"
                            name="name"
                            label="姓名"
                            placeholder="姓名"
                            :rules="[{ required: true, message: '请填写姓名' }]"
                    />

                    <van-field
                            v-model="item.id_card"
                            :required="true"
                            name="id_card"
                            label="身份证"
                            placeholder="身份证"
                            :rules="[{ required: true, message: '请填写身份证' }]"
                    />


                    <van-field :required="true" name="file_id_card_front" label="身份证正面(头像)">
                        <template #input>
                            <van-uploader name="id_card_front" v-model="file_id_card_front" :max-count="1"
                                          :after-read="afterRead"/>
                        </template>
                    </van-field>

                    <van-field :required="true" name="file_id_card_back" label="身份证反面(国徽)">
                        <template #input>
                            <van-uploader name="id_card_back" v-model="file_id_card_back" :max-count="1"
                                          :after-read="afterRead"/>
                        </template>
                    </van-field>


                    <van-field :required="true" name="file_id_card_avatar" label="证件照">
                        <template #input>
                            <van-uploader name="id_card_avatar" v-model="file_id_card_avatar" :max-count="1"
                                          :after-read="afterRead"/>
                        </template>
                    </van-field>


                    <van-field name="file_education_materials" label="学历证照">
                        <template #input>
                            <van-uploader name="education_materials" v-model="file_education_materials" :max-count="1"
                                          :after-read="afterRead"/>
                        </template>
                    </van-field>


                    <div style="margin: 16px;">
                        <van-button round block type="info" native-type="submit">
                            立即登记
                        </van-button>
                    </div>
                </van-form>
            </van-row>
        </van-row>


        <van-row v-show="'success'==step">
            <van-row style="text-align: center">
                <van-icon name="passed" size="150" color="green"/>
                <p style="font-size: 1.5em">登 记 成 功</p>
            </van-row>
        </van-row>

        <van-overlay :show="loading" style="display: flex;align-items: center;justify-content: center;height: 100%;">
            <van-loading size="24px" vertical>登记中...</van-loading>
        </van-overlay>

    </van-row>
</template>

<script>
export default {
    data() {
        return {
            step: "",
            loading: false,
            showCategoryPicker: false,
            showQualificationsPicker: false,
            categories: [],

            showPickerBirthDate: false,
            showPickerTermOffice: false,
            showPickerEthnicity: false,

            category: {
                index: "",
                name: "",
                children: ""
            },

            file_id_card_avatar: [],
            file_id_card_front: [],
            file_id_card_back: [],
            file_education_materials: [],


            item: {
                name: "",
                sex: "",
                id_card: "",
                phone: "",
                qualifications: "",
                organ_name: "",
                type: "",
                category_name: "",
                id_card_avatar: "",
                id_card_front: "",
                id_card_back: "",
                education_materials: "",

                term_office: "",
                organ_address: "",
                position: "",
                ethnicity: "",
                birth_date: "",
                home_address: "",
                health_status: "",
                personnel_type: "",
                work_experience: "",
            }
        };
    },
    created() {
    },
    methods: {
        onConfirmBirthDate(time) {
            this.item.birth_date = this.$moment(time).format("YYYY-MM-DD")
            this.showPickerBirthDate = false
        },
        onConfirmTermOffice(time) {
            this.item.term_office = this.$moment(time).format("YYYY-MM-DD")
            this.showPickerTermOffice = false
        },
        ethnicityOnConfirm(value){
            this.item.ethnicity=value
            this.showPickerEthnicity=false
        },

        chooseParentCategory(cate_index) {
            this.category.name = this.categories[cate_index].name
            this.category.children = this.categories[cate_index].children
        },
        categoryOnConfirm(value) {
            this.showCategoryPicker = false
            this.item.category_name = value
        },
        qualificationsOnConfirm(value) {
            this.showQualificationsPicker = false
            this.item.qualifications = value
        },
        dataURLtoFile(dataurl, filename) {
            let arr = dataurl.split(',');
            let mime = arr[0].match(/:(.*?);/)[1];
            let bstr = atob(arr[1]);
            let n = bstr.length;
            let u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n)
            }
            return new File([u8arr], filename, {type: mime});
        },
        afterRead(file, source) {
            console.log(source)

            file.status = 'uploading';
            file.message = '上传中...';

            let fileSize = parseFloat(parseInt(file.file['size']) / 1024 / 1024).toFixed(2);
            const img = new Image();
            img.src = file.content; // 指定图片的DataURL(图片的base64编码数据)
            img.onload = () => {
                const canvas = document.createElement('canvas'); // 创建Canvas对象(画布)
                const context = canvas.getContext('2d');
                //默认按比例压缩
                let cw = img.width;
                let ch = img.height;
                let w = img.width;
                let h = img.height;
                canvas.width = w;
                canvas.height = h;
                if (cw > 500 && cw > ch) {
                    w = 500;
                    h = (500 * ch) / cw;
                    canvas.width = w;
                    canvas.height = h;
                }
                if (ch > 500 && ch > cw) {
                    h = 500;
                    w = (500 * cw) / ch;
                    canvas.width = w;
                    canvas.height = h;
                }
                //生成canvas
                let base64;
                // 创建属性节点
                context.clearRect(0, 0, 0, w, h);
                context.drawImage(img, 0, 0, w, h);

                const formData = new FormData()
                if (fileSize > 2) {
                    //如果图片超过2m,则进行压缩
                    base64 = canvas.toDataURL(file.file['type'], 0.94);
                    formData.append('file', this.dataURLtoFile(base64, file.file.name))
                } else {
                    formData.append('file', file.file)
                }

                this.$http.post("/backend/common/upload", formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    onUploadProgress: progressEvent => {
                        console.log('上传进度：', Math.round((progressEvent.loaded / progressEvent.total) * 100))
                    }
                }).then(res => {
                    console.log('上传成功：', res.data.data.url)
                    file.status = "done"
                    file.message = "上传成功"

                    switch (source.name) {
                        case "id_card_avatar":
                            this.item.id_card_avatar = res.data.data.path
                            break;
                        case "id_card_front":
                            this.item.id_card_front = res.data.data.path
                            break;
                        case "id_card_back":
                            this.item.id_card_back = res.data.data.path
                            break;
                        case "education_materials":
                            this.item.education_materials = res.data.data.path
                            break;
                    }
                }).catch(err => {
                    file.status = 'failed';
                    file.message = '上传失败';
                    console.error('上传失败：', err)
                })
            };

        },

        onSubmit() {
            if (this.item.id_card_avatar.length <= 0) {
                // this.$dialog.alert({title: '登记失败', message: "请上传证件照"})
                // return
            }
            if (this.item.id_card_front.length <= 0) {
                // this.$dialog.alert({title: '登记失败', message: "请上传身份证正面"})
                // return
            }
            if (this.item.id_card_back.length <= 0) {
                // this.$dialog.alert({title: '登记失败', message: "请上传身份证反面"})
                // return
            }
            if (this.item.education_materials.length <= 0) {
                // this.$dialog.alert({title: '登记失败', message: "请上传学历材料"})
                // return
            }
            this.loading = true

            this.$http.post("/wechat/register", this.item).then(res => {
                this.loading = false
                console.log(res.data);
                if (200 !== res.data.code) {
                    this.$toast.fail(res.data.msg);
                } else {
                    this.step = "success";
                }
            });

        },

    },
}
</script>
